<template>
  <v-dialog content-class="casino-dialog-container" persistent :fullscreen="mobileBigAndBelow" v-model="vModelCondition" :max-width="!mobileBigAndBelow ? '70%' : ''">
    <div class="buttons-container">
      <div class="close iframe-btn" @click="closeDialog()"></div>
    </div>
    <casino-launcher v-if="casinoLauncherDialogState" :gameData="casinoLauncherDialogState"></casino-launcher>
  </v-dialog>
</template>

<script>
import casinoLauncher from '@/components/igaming/partials/casinoLauncher.vue'
import store from '@/store'
import Screen from '@/components/mixins/Screen'
import Session from '@/components/mixins/Session'
import Casino from '@/components/mixins/Casino'
import Branding from '@/components/mixins/Branding'
import lib from '@/library'
export default {
  name: 'casinoLauncherDialog',
  props: {},
  components: {
    casinoLauncher
  },
  data () {
    return {
      show: true

    }
  },
  mixins: [
    Screen,
    Branding,
    Casino,
    Session
  ],
  computed: {
    casinoLauncherDialogState () {
      console.log('CASINO GAME DATA', store.getters['overlayState/getCasinoLauncherDialogState'])
      return store.getters['overlayState/getCasinoLauncherDialogState']
    },
    isLoggedIn () {
      return store.getters['isLoggedIn']
    },
    vModelCondition () {
      return this.show && this.casinoLauncherDialogState
    },
    userAgent () {
      return lib.core.userAgent.os.name
    }
  },

  methods: {
    closeDialog (sessionExpired = false) {
      store.dispatch('overlayState/activateCasinoLauncherDialog', false)
      this.show = false
      if (!sessionExpired) {
        store.dispatch('getCustomerContext')
        this.userIsActive()
      }
    }
  },

  mounted () {},
  beforeDestroy () {
    store.commit('overlayState/setCasinoLauncherDialogState', false)
  },
  watch: {
    isLoggedIn (newVal) {
      if (!newVal) {
        this.closeDialog(true)
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/igaming/partials/casinoLauncherDialog.vue